import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {SharedImports} from '@shared/shared-imports';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {GenericSelectModel} from '@app/models/generic-select.model';
import {LookupsDataService} from '@services/lookups-data.service';
import {ContextService} from '@services/context.service';
import {OrganizationRegistrationModel} from '@app/models/organizations.model';
import {SelfRegistrationModel} from '@app/models/user-registration.model';
import {ConfirmValidationUtility} from '@shared/utilities/confirm-validation.utility';

@Component({
  selector: 'app-registration-page-2',
  templateUrl: './registration-page-2-security.component.html',
  styleUrls: ['./registration-page-2-security.component.scss'],
  imports: [
    SharedImports,
  ]
})

export class RegistrationPage2SecurityComponent implements OnInit, OnChanges {
  mainForm: FormGroup;
  passwordType = 'password';
  passwordConfirmType = 'password';
  inputObjQuestion1: GenericSelectModel;
  inputObjQuestion2: GenericSelectModel;
  inputObjQuestion3: GenericSelectModel;
  setQuestion1Id: number;
  setQuestion2Id: number;
  setQuestion3Id: number;
  @Output() next = new EventEmitter<any>();
  @Output() updateData = new EventEmitter<any>();
  @Input() registrationProfile: SelfRegistrationModel;
  @Input() campaignId: number;
  @Input() organizationDetails: OrganizationRegistrationModel;

  constructor(private formBuilder: FormBuilder, private confirmValidationUtility: ConfirmValidationUtility,
              private lookupsDataService: LookupsDataService, public contextService: ContextService) {
    this.mainForm = this.formBuilder.group({
      password: new FormControl(null, [Validators.required,
        this.regexValidator(new RegExp('^.*[A-Za-z0-9$@#!%*?&].{9,}'), {length: true}),
        this.regexValidator(new RegExp('^.*[a-z]'), {lowercase: true}),
        this.regexValidator(new RegExp('^.*[A-Z]'), {uppercase: true}),
        this.regexValidator(new RegExp('^.*[0-9]'), {number: true}),
        this.regexValidator(new RegExp('^.*[$@#!%*?&]'), {special: true}),
        this.regexValidator(new RegExp('^(?!.*([a-zA-Z0-9$@#!%*?&])\\1{2,})'), {repeats: true})
      ]),
      // password: new FormControl('', [Validators.required,
      //   Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])(?!.*([a-zA-Z0-9])\\1{2,})[A-Za-zd$@$!%*?&].{9,}')]),
      showPassword: new FormControl(false),
      passwordConfirm: new FormControl(null, Validators.required),
      showPasswordConfirm: new FormControl(false),
      question1: new FormControl(null, Validators.required),
      question2: new FormControl(null, Validators.required),
      question3: new FormControl(null, Validators.required),
      answer1: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(100)]),
      answer2: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(100)]),
      answer3: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(100)]),
    }, {
      validator: [this.confirmValidationUtility.ConfirmedValidator('password', 'passwordConfirm'),
        this.customValidator('name', 'password')]
    });
  }

  ngOnInit() {
    document.querySelector('.page-container-public').scrollIntoView(true);
    this.mainForm.controls.showPassword.valueChanges.subscribe({
      next: (val) => {
        this.passwordType = val === true ? 'text' : 'password';
      }
    });

    this.mainForm.controls.showPasswordConfirm.valueChanges.subscribe({
      next: (val) => {
        this.passwordConfirmType = val === true ? 'text' : 'password';
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.registrationProfile && this.registrationProfile) {
      if (this.registrationProfile.SecurityQuestionResponses) {
        this.mainForm.get('password').setValue(this.registrationProfile.Password);
        this.mainForm.get('question1').setValue(this.registrationProfile.SecurityQuestionResponses.QuestionID1);
        this.mainForm.get('question2').setValue(this.registrationProfile.SecurityQuestionResponses.QuestionID2);
        this.mainForm.get('question3').setValue(this.registrationProfile.SecurityQuestionResponses.QuestionID3);
        this.mainForm.get('answer1').setValue(this.registrationProfile.SecurityQuestionResponses.QuestionResponse1);
        this.mainForm.get('answer2').setValue(this.registrationProfile.SecurityQuestionResponses.QuestionResponse2);
        this.mainForm.get('answer3').setValue(this.registrationProfile.SecurityQuestionResponses.QuestionResponse3);
      }
      this.initData();
    }

  }

  customValidator(unControlName: string, pswdControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[unControlName];
      const matchingControl = formGroup.controls[pswdControlName];
      if (matchingControl.errors && !matchingControl.errors?.customValidator) {
        return;
      }
      const am: number = control?.value?.indexOf('@');
      const username: string = control?.value?.substring(0, am);
      const domain: string = control?.value?.substring(am + 1, control.value.length);
      if (matchingControl.value.indexOf(username) > -1 || matchingControl.value.indexOf(domain) > -1) {
        matchingControl.setErrors({customValidator: true});
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  regexValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    };
  }

  initData() {
    this.mainForm.valueChanges.subscribe(data => {
      this.registrationProfile.Password = this.mainForm.get('password').value;
      this.updateData.emit(this.registrationProfile);
    });
    this.initQuestion1(false);
    this.initQuestion2(false);
    this.initQuestion3(false);
  }

  initQuestion1(disable: boolean): void {
    this.inputObjQuestion1 = {
      labelText: 'Question #1',
      optionValue: 'ID',
      optionLabel: 'Description',
      filter: false,
      requiredField: true,
      selectFirstValue: false,
      initSelected: this.registrationProfile?.SecurityQuestionResponses?.QuestionID1 ? this.registrationProfile?.SecurityQuestionResponses?.QuestionID1 : null,
      data: null,
      disabled: disable
    };
    this.lookupsDataService.getSecurityQuestionsLookupData(1).then((lookupData) => {
      this.inputObjQuestion1.data = lookupData;
      this.inputObjQuestion1 = Object.assign({}, this.inputObjQuestion1);
    });
  }

  getQuestion1Data(event: any) {
    if (event && event[0] && event[0].ID) {
      this.setQuestion1Id = event[0].ID;
    } else {
      this.setQuestion1Id = null;
    }
    this.mainForm.get('question1').setValue(this.setQuestion1Id);
  }

  initQuestion2(disable: boolean): void {
    this.inputObjQuestion2 = {
      labelText: 'Question #2',
      optionValue: 'ID',
      optionLabel: 'Description',
      filter: false,
      requiredField: true,
      selectFirstValue: false,
      initSelected: this.registrationProfile?.SecurityQuestionResponses?.QuestionID2 ? this.registrationProfile?.SecurityQuestionResponses?.QuestionID2 : null,
      data: null,
      disabled: disable
    };
    this.lookupsDataService.getSecurityQuestionsLookupData(2).then((lookupData) => {
      this.inputObjQuestion2.data = lookupData;
      this.inputObjQuestion2 = Object.assign({}, this.inputObjQuestion2);
    });
  }

  getQuestion2Data(event: any) {
    if (event && event[0] && event[0].ID) {
      this.setQuestion2Id = event[0].ID;
    } else {
      this.setQuestion2Id = null;
    }
    this.mainForm.get('question2').setValue(this.setQuestion2Id);
  }

  initQuestion3(disable: boolean): void {
    this.inputObjQuestion3 = {
      labelText: 'Question #3',
      optionValue: 'ID',
      optionLabel: 'Description',
      filter: false,
      requiredField: true,
      selectFirstValue: false,
      initSelected: this.registrationProfile?.SecurityQuestionResponses?.QuestionID3 ? this.registrationProfile?.SecurityQuestionResponses?.QuestionID3 : null,
      data: null,
      disabled: disable
    };
    this.lookupsDataService.getSecurityQuestionsLookupData(3).then((lookupData) => {
      this.inputObjQuestion3.data = lookupData;
      this.inputObjQuestion3 = Object.assign({}, this.inputObjQuestion3);

    });


  }

  getQuestion3Data(event: any) {
    if (event && event[0] && event[0].ID) {
      this.setQuestion3Id = event[0].ID;
    } else {
      this.setQuestion3Id = null;
    }
    this.mainForm.get('question3').setValue(this.setQuestion3Id);
  }


  goToNextPage() {
    this.registrationProfile.Password = this.mainForm.get('password').value;
    this.registrationProfile.SecurityQuestionResponses = {
      QuestionID1: this.mainForm.get('question1').value,
      QuestionID2: this.mainForm.get('question2').value,
      QuestionID3: this.mainForm.get('question3').value,
      QuestionResponse1: this.mainForm.get('answer1').value,
      QuestionResponse2: this.mainForm.get('answer2').value,
      QuestionResponse3: this.mainForm.get('answer3').value
    };
    this.updateData.emit(this.registrationProfile);
    this.next.emit();
  }

}
